/**
 * カスタム商品詳細向けバリエーションUI
 * - 初期表示の variant JSON（全価格入り）を使って価格を即時更新
 * - 重い section_id fetch（renderProductInfo）をスキップ
 * - バリエーション画像を Slick に同期
 */
(function () {
  function centsToYen(cents) {
    return Math.round(Number(cents) / 100);
  }

  function formatYen(yen) {
    return '¥' + Number(yen).toLocaleString('ja-JP');
  }

  function formatVariantPrice(variant) {
    if (!variant || typeof variant.price !== 'number') return '';
    return formatYen(centsToYen(variant.price));
  }

  function getPriceEl(sectionId) {
    if (sectionId) {
      var el = document.getElementById('price-' + sectionId);
      if (el) return el;
    }
    return document.querySelector('[id^="price-template"], [id^="price-"]');
  }

  function updatePriceFromVariant(variant, sectionId) {
    var priceEl = getPriceEl(sectionId);
    if (!priceEl || !variant) return;
    var text = formatVariantPrice(variant);
    if (!text) return;
    priceEl.textContent = text;
    priceEl.classList.remove('visibility-hidden');
  }

  function getVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    return null;
  }

  function getVariantImageSrc(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return '';
  }

  function findSlideIndex(variant) {
    if (!variant || typeof window.jQuery === 'undefined') return -1;

    var $slider = window.jQuery('.sliderBox .topBox');
    if (!$slider.length || !$slider.hasClass('slick-initialized')) return -1;

    var mediaId = getVariantMediaId(variant);
    var imageSrc = getVariantImageSrc(variant);
    var index = -1;

    $slider.find('.slick-slide:not(.slick-cloned) [data-media-id]').each(function (i) {
      if (mediaId && String(this.getAttribute('data-media-id')) === String(mediaId)) {
        index = i;
        return false;
      }
    });

    if (index < 0 && imageSrc) {
      var srcNeedle = imageSrc.split('?')[0];
      $slider.find('.slick-slide:not(.slick-cloned) img').each(function (i) {
        var slideSrc = (this.currentSrc || this.src || '').split('?')[0];
        if (slideSrc && srcNeedle && (slideSrc === srcNeedle || slideSrc.indexOf(srcNeedle) !== -1 || srcNeedle.indexOf(slideSrc) !== -1)) {
          index = i;
          return false;
        }
      });
    }

    return index;
  }

  function safeSlickGoTo($el, index, instant) {
    if (!$el || !$el.length) return;
    if (!$el.hasClass('slick-initialized')) return;
    try {
      if (instant) {
        $el.slick('slickGoTo', index, true);
      } else {
        $el.slick('slickGoTo', index);
      }
    } catch (e) {
      // Slick 未初期化・破棄済みでもバリエーション更新を止めない
    }
  }

  function goToVariantMedia(variant) {
    if (!variant || typeof window.jQuery === 'undefined') return;
    if (!getVariantMediaId(variant) && !getVariantImageSrc(variant)) return;

    var index = findSlideIndex(variant);
    if (index < 0) return;

    safeSlickGoTo(window.jQuery('.sliderBox .topBox'), index);
    safeSlickGoTo(window.jQuery('.slidePop ul'), index, true);
  }

  function updateLoanFromVariant(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    if (typeof window.jQuery === 'undefined') return;

    var $loan = window.jQuery('.loancal');
    if (!$loan.length) return;

    var priceYen = centsToYen(variant.price);
    window.jQuery('.loanPrice').val(priceYen.toLocaleString('ja-JP'));

    var split = parseFloat($loan.attr('data-loan-split'));
    if (!split) return;

    var monthly = priceYen / split;
    if (monthly < 3000) {
      window.jQuery('.js_price').text('3,000');
    } else {
      monthly = Math.floor(monthly / 100) * 100;
      window.jQuery('.js_price').text(monthly.toLocaleString('ja-JP'));
    }
  }

  function isQuantityRuleSoldout(variant) {
    if (!variant) return false;
    var checkAgainstInventory = variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
    if (!checkAgainstInventory) return false;
    var min = variant.quantity_rule && variant.quantity_rule.min;
    if (typeof min !== 'number') return false;
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
    return min > qty;
  }

  function getPurchaseMode(variant, box) {
    if (!variant) return 'soldout';

    var forceSoldout = box && box.getAttribute('data-force-soldout') === 'true';
    var online = box && box.getAttribute('data-online') === 'true';
    var available = !!variant.available;

    if (forceSoldout && available && online) return 'cart';
    if (forceSoldout && !available) return 'soldout';
    if (!available || isQuantityRuleSoldout(variant)) return 'inquiry';
    if (!online) return 'inquiry';
    return 'cart';
  }

  function applyPurchaseMode(box, mode) {
    var cartBtn = box.querySelector('.js_purchase_cart');
    var inquiryBtn = box.querySelector('.js_purchase_inquiry');
    if (!cartBtn || !inquiryBtn) return;

    var cartLabel = cartBtn.querySelector('span');

    if (mode === 'inquiry') {
      cartBtn.classList.add('hidden');
      cartBtn.setAttribute('disabled', 'disabled');
      inquiryBtn.classList.remove('hidden');
      return;
    }

    inquiryBtn.classList.add('hidden');
    cartBtn.classList.remove('hidden');

    if (mode === 'soldout') {
      cartBtn.setAttribute('disabled', 'disabled');
      if (cartLabel) cartLabel.textContent = '売り切れ';
      return;
    }

    cartBtn.removeAttribute('disabled');
    if (cartLabel) cartLabel.textContent = 'カートに入れる';
  }

  function updatePurchaseButtons(variant) {
    document.querySelectorAll('[data-purchase-box]').forEach(function (box) {
      applyPurchaseMode(box, getPurchaseMode(variant, box));
    });
  }

  function getCurrentVariantFromPicker() {
    var picker = document.querySelector('variant-selects, variant-radios');
    if (!picker || typeof picker.getVariantData !== 'function') return null;

    if (picker.currentVariant) return picker.currentVariant;

    if (typeof picker.updateOptions === 'function' && typeof picker.updateMasterId === 'function') {
      picker.updateOptions();
      picker.updateMasterId();
      return picker.currentVariant || null;
    }

    return null;
  }

  function patchVariantSelects() {
    if (typeof VariantSelects === 'undefined') return;

    var originalUpdateMedia = VariantSelects.prototype.updateMedia;
    VariantSelects.prototype.updateMedia = function () {
      try {
        if (typeof originalUpdateMedia === 'function') {
          originalUpdateMedia.call(this);
        }
      } catch (e) {
        // media-gallery が無いカスタムPDPでも後続のURL/価格更新を止めない
      }
      goToVariantMedia(this.currentVariant);
    };

    // Dawn の売り切れ上書きを止めて、Liquid と同じ購入ボタン判定にする
    VariantSelects.prototype.toggleAddButton = function () {
      updatePurchaseButtons(this.currentVariant);
    };

    // 重い section fetch をやめて、初期JSONの価格で即時更新
    VariantSelects.prototype.renderProductInfo = function () {
      var variant = this.currentVariant;
      if (!variant) return;

      var sectionId = this.dataset.originalSection || this.dataset.section;
      updatePriceFromVariant(variant, this.dataset.section);
      goToVariantMedia(variant);
      updateLoanFromVariant(variant);
      updatePurchaseButtons(variant);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: sectionId,
            html: null,
            variant: variant
          }
        });
      }
    };
  }

  function syncInitialVariantMedia() {
    var params = new URLSearchParams(window.location.search);
    if (!params.get('variant')) return;

    var variant = getCurrentVariantFromPicker();
    if (!variant) return;
    goToVariantMedia(variant);
    updatePriceFromVariant(variant);
  }

  function bindVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      goToVariantMedia(variant);
      updateLoanFromVariant(variant);
    });
  }

  patchVariantSelects();
  bindVariantChange();

  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(function () {
      window.setTimeout(syncInitialVariantMedia, 0);
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(syncInitialVariantMedia, 0);
    });
  }
})();
